import cn from 'classnames';
import {FormikProps} from 'formik';
import {ChangeEvent, useState} from 'react';

type TabKey = 'description' | 'combinations' | 'application_method';

type TabsType = {key: TabKey; label: string}[];

const TABS: TabsType = [
  {key: 'description', label: 'توضیحات'},
  {key: 'combinations', label: 'ترکیبات'},
  {key: 'application_method', label: 'روش مصرف'},
];
type TabbedFields = {
  description?: string | null;
  combinations?: string | null;
  application_method?: string | null;
};

type Props<T extends TabbedFields> = {
  form: FormikProps<T>;
};

// this component is suitable for useFormik
const TabbedDescriptionTextareaUseForm = <T extends TabbedFields>({
  form,
}: Props<T>) => {
  const [activeTab, setActiveTab] = useState<TabKey>('description');

  const activeTabConfig = TABS.find(t => t.key === activeTab)!;

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    form.setFieldValue(activeTabConfig.key, e.target.value);
  };

  return (
    <section>
      {/* Tabs */}
      <div className="flex gap-6 mb-2">
        {TABS.map(tab => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActiveTab(tab.key)}
            className={cn(
              'py-1 font-medium text-md rounded',
              activeTab === tab.key ? 'text-farm-shop-500' : 'text-gray-700',
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Textarea */}
      <textarea
        rows={5}
        className="w-full p-2 border border-gray-700 rounded outline-none text-md"
        placeholder={`${activeTabConfig.label} محصول را بنویسید`}
        value={form.values[activeTabConfig.key] ?? ''}
        onChange={handleChange}
      />
    </section>
  );
};

export default TabbedDescriptionTextareaUseForm;
